var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAosStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53437 26.5027C4.17843 26.325 4.00049 25.8806 4.00049 25.4362C4.00049 25.3473 4.00049 25.1696 4.00049 25.0807C4.00049 18.5037 4.00049 11.9267 4.00049 5.43867C4.00049 5.08315 4.08946 4.81656 4.17843 4.46104C4.26745 4.28325 4.4454 4.10552 4.62339 3.92779C8.44961 7.74951 12.1869 11.5712 15.9241 15.393C12.0979 18.9481 8.36063 22.681 4.53437 26.5027Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6612 11.4824C18.5934 12.5489 17.4366 13.6154 16.3688 14.7708C12.8095 11.1268 9.16127 7.48286 5.60197 3.83887C5.60197 3.83887 5.60197 3.75 5.69094 3.75C10.318 6.32744 14.9451 8.90493 19.6612 11.4824Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60197 26.5027C9.16127 22.9476 12.8095 19.3925 16.3688 15.8374C17.3476 16.815 18.4154 17.7927 19.5722 18.8592C14.9451 21.4367 10.318 24.0141 5.69094 26.5027H5.60197Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1954 18.5037C19.0386 17.4372 17.9709 16.3706 16.8141 15.3041C17.9709 14.1487 19.1277 12.9933 20.2844 11.8379C20.6403 12.0156 20.9963 12.1934 21.3522 12.46C22.242 12.9933 23.2209 13.4377 24.1107 13.9709C24.3776 14.0598 24.5556 14.2376 24.7335 14.5042C25.0894 14.9486 25.0894 15.393 24.7335 15.8374C24.5556 16.0151 24.3776 16.1929 24.1107 16.2818C22.8649 17.0817 21.5302 17.7927 20.1954 18.5037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAosStore);
export default __webpack_public_path__ + "static/media/aos-store.e580e03cbe626e3b1c6e49634d8385d5.svg";
export { ForwardRef as ReactComponent };